exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@-moz-document url-prefix(){[layout-fill]{margin:0;width:100%;min-height:100%;height:100%}}:host.below-app-grid{display:block;width:350px;margin-top:10px}", ""]);

